import { create } from "zustand";
import type { OrganizationTypePosition } from "../types";

interface PositionsState {
	modalOpen: boolean;
	editingItem: OrganizationTypePosition | null;
}

interface PositionsActions {
	openCreateModal: () => void;
	openEditModal: (item: OrganizationTypePosition) => void;
	onOpen: (item?: OrganizationTypePosition) => void;
	closeModal: () => void;
}

type PositionsStore = PositionsState & PositionsActions;

export const usePositionsStore = create<PositionsStore>((set) => ({
	modalOpen: false,
	editingItem: null,

	openCreateModal: () => {
		set({ modalOpen: true, editingItem: null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	onOpen: (item) => {
		set({ modalOpen: true, editingItem: item ?? null });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null });
	},
}));
